import { Box } from '@mui/material';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { appName } from '../../lib/config';
import { Section } from '../App/typescript';
import Navbar from '../Navbar';
import { NavbarItemInterface } from '../Navbar/NavbarItem';
import NavbarLeftItems from '../Navbar/NavbarLeftItems';
import NavbarMenu from '../Navbar/NavbarMenu';
import NavbarSearch from '../Navbar/NavbarSearch';
import NavbarSignIn from '../Navbar/NavbarSignIn';

import DeepCanvassingLogo from './logos/deep-canvassing.png';
import glappLogo from './logos/glapp.svg';

const logos: Record<string, string> = {
  deep_canvassing: DeepCanvassingLogo,
  glapp: glappLogo,
};

interface ProHeaderProps {
  primaryItems: NavbarItemInterface[];
  secondaryItems: NavbarItemInterface[];
}

const Header: FC<ProHeaderProps> = ({ primaryItems, secondaryItems }) => {
  return (
    <Navbar>
      <NavbarLeftItems menuItems={primaryItems} />
      <Box
        component={Link}
        sx={{
          flexBasis: '37em',
          textAlign: 'center',
        }}
        to="/"
      >
        <Box alt="" component="img" src={logos[appName]} sx={{ paddingY: '0.5em' }} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexBasis: '100%',
          flexShrink: 1,
          height: '100%',
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
          }}
        />
        {GLOBALS.section === Section.Admin && <NavbarSearch />}
        <NavbarSignIn />
        <NavbarMenu primaryItems={primaryItems} secondaryItems={secondaryItems} />
      </Box>
    </Navbar>
  );
};

export default Header;
